import { apiDelete, apiGet, apiPatch, apiPost } from '@/infrastructure/api-client';
import type {
  HistoryResponse,
  SnapshotDetail,
  SnapshotSummary,
} from '@/domain/history/contracts';

const base = (funnelId: string) => `/api/funnels/${encodeURIComponent(funnelId)}/history`;

export const listHistory = (funnelId: string): Promise<HistoryResponse> => apiGet(base(funnelId));
export const createVersion = (
  funnelId: string,
  label: string | null,
): Promise<{ snapshot: SnapshotSummary }> => apiPost(base(funnelId), { label });
export const getVersion = (
  funnelId: string,
  snapshotId: string,
): Promise<{ snapshot: SnapshotDetail }> => apiGet(`${base(funnelId)}/${snapshotId}`);
export const updateVersion = (
  funnelId: string,
  snapshotId: string,
  values: { label?: string | null; isPinned?: boolean },
): Promise<{ ok: true }> => apiPatch(`${base(funnelId)}/${snapshotId}`, values);
export const deleteVersion = (
  funnelId: string,
  snapshotId: string,
): Promise<{ ok: true }> => apiDelete(`${base(funnelId)}/${snapshotId}`);
export const restoreVersion = (
  funnelId: string,
  snapshotId: string,
  expectedRevision: number,
): Promise<{ revision: number; restoredFromRevision: number }> =>
  apiPost(`${base(funnelId)}/${snapshotId}/restore`, { expectedRevision });

